<template>
  <section class="w-full bg-blue-50 py-20">
    <div class="container mx-auto px-4">
      <div class="max-w-3xl mx-auto">
        <h2 class="text-3xl font-bold text-blue-900 mb-6 text-center">
          About Fairmont Park LLC
        </h2>
        <p class="text-blue-800/70 mb-4">
          Fairmont Park LLC is a premier property management company based in
          New York City. With years of industry experience, we specialize in
          managing residential and commercial properties throughout the city's
          diverse neighborhoods.
        </p>
        <p class="text-blue-800/70 mb-4">
          Our team of professionals is dedicated to maximizing property values
          while providing exceptional service to both property owners and
          tenants. We handle everything from day-to-day operations to
          long-term strategic planning.
        </p>
        <p class="text-blue-800/70">
          At Fairmont Park LLC, we believe in building lasting relationships
          with our clients through transparency, integrity, and results-driven
          management practices.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutUs"
}
</script>